import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import '@/core/rem.js'

import Vant from 'vant';
import 'vant/lib/index.css';
import './styles/styles.scss';

// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";

import components from './core/components';
import http from './core/http';
import core from './core/core';

import changeStorage from './core/changeStorage'

Vue.use(Vant);
Vue.use(VueEasytable);
Vue.use(core);

Vue.prototype.$http = http;
Vue.config.ignoredElements.push('wx-open-launch-weapp');

Vue.prototype.$storage=changeStorage;//加入vue的原型对象

// 自动化注册组件
Vue.use(components)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
